// extracted by mini-css-extract-plugin
export default {"banner":"ErrorBanner_banner__zGFWk","title":"ErrorBanner_title__+QQAv","body":"ErrorBanner_body__O1qey"};